export const subscription = {
  "title": "Subscription",
  "plan": {
    "monthly": "Monthly",
    "yearly": "Yearly",
    "by-monthly": ", monthly",
    "by-yearly": ", yearly",
    "price-type": {
      "monthly": "mo",
      "yearly": "yr"
    },
    "SavePrice": "Save ",
    "Subscribe": "Subscribe",
    "Subscribed": "Subscribed",
    "business": {
      "name": "Foxit PDF Editor Pro",
      "monthly": "Subscription for Foxit PDF Editor Pro, monthly",
      "yearly": "Subscription for Foxit PDF Editor Pro, yearly",
      "org": "Foxit PDF Editor Pro Organization",
      "info1": "All Foxit PDF Editor Pro features",
      "info3": "All Foxit PDF Editor Cloud features"
    },
    "standard": {
      "name": "Foxit PDF Editor for Windows",
      "monthly": "Subscription for Foxit PDF Editor for Windows, monthly",
      "yearly": "Subscription for Foxit PDF Editor for Windows, yearly",
      "org": "Foxit PDF Editor Organization",
      "info1": "All Foxit PDF Editor features",
      "info3": "All Foxit PDF Editor Cloud features"
    },
    "education": {
      "name": "Foxit PDF Editor Education",
      "monthly": "Subscription for Foxit PDF Editor Education, monthly",
      "yearly": "Subscription for Foxit PDF Editor Education, yearly",
      "org": "Foxit PDF Editor Education Organization",
      "info1": "Free Foxit PDF Editor features available",
      "info3": "All Foxit PDF Editor Cloud features"
    },
    "online": {
      "name": "Foxit PDF Editor Cloud",
      "monthly": "Subscription for Foxit PDF Editor Cloud, monthly",
      "yearly": "Subscription for Foxit PDF Editor Cloud, yearly",
      "org": "Foxit PDF Editor Cloud Organization",
      "info1": "Free Foxit PDF Editor features available",
      "info3": "All Foxit PDF Editor Cloud features"
    }
  },
  "error": {
    "GetSubscriptionInfoFailed": "Subscription validation request timed out"
  },
  "2023SubscribeStrategy": {
    "Enterprise": {
      "Bundle": {
        "OkBtn": "OK",
        "UpgradeBtn": "Upgrade",
        "FreeTrialBtn": "Trial",
        "Expired": "Your subscription has expired, please upgrade your subscription or contact your Foxit account administrator.",
        "ExpiredForTeams": "Your subscription has expired, to get a new subscription, please contact your Foxit account administrator or visit: ",
        "AddToCardForTeams": "Foxit Store",
        "FreeTrial": "The feature you are attempting to use requires a subscription. Click the trial button for 14-day free trial.",
        "FreeTrialForTeams": "The feature you are attempting to use requires a subscription. For 14-day free trial, please contact your Foxit account administrator or visit: ",
        "ContactAdmin": "You do not have access to this advanced tool. Please contact an administrator to activate your account.",
        "StartFreeTrialForTeams": "Free Trial",
      },
      "Cloud": {
        "UpgradeBtn": "Upgrade",
        "Expired": "Your subscription has expired, please upgrade your subscription or contact your Foxit account administrator.",
      }
    },
    "Personal": {
      "Bundle": {
        "UpgradeBtn": "Upgrade",
        "FreeTrialBtn": "Trial",
        "Expired": "Your subscription has expired, please upgrade your subscription or contact your Foxit account administrator.",
        "FreeTrial": "The feature you are attempting to use requires a subscription. Click the trial button for 14-day free trial.",
      },
      "Cloud": {

      },
      "OrganizationOnly": {
        "OkBtn": "OK",
        "Alert": "The feature you are attempting to use requires purchase of PDF Editor Suite Pro for Teams / PDF Editor Suite for Teams. Please contact your organization administrator.",
        "ContactUs": "Contact Us",
      }
    }
  }
}